module.exports = __webpack_public_path__ + "static/media/dorso.70f327d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/dorso.png
// module id = 656
// module chunks = 0